import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=534d724a&"
import script from "./Sidebar.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534d724a')) {
      api.createRecord('534d724a', component.options)
    } else {
      api.reload('534d724a', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=534d724a&", function () {
      api.rerender('534d724a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/layout/Sidebar.vue"
export default component.exports